export const NEW_RANGE_CONFIGURATIONS = 'newRangeConfigurations';

export const configureRangesText =
  'Define the product ranges that will be displayed in your menu. Adjusting these ranges will update the menu items to the latest version.';

export const newRangeConfigurationsCheckboxText =
  'I acknowledge and accept the new range configurations and understand their impact on menu items.';

export const mustSelectRangeErrorMessage = 'Must select one or more ranges before you can create your menu';
